module.exports = __webpack_public_path__ + "static/media/arrow-left-dark.5e4e3755.svg";